module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-titlea"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Structure#str"
    }
  }, [_vm._v("Structure and Organisation of the Book")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#som"
    }
  }, [_vm._v("Some Guidance Notes for the Reader")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_01"
    }
  }, [_vm._v("A Note on Spanish Units of Weights and Measurements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_02"
    }
  }, [_vm._v("A Note on How Measurements Relate to Vessels")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_03"
    }
  }, [_vm._v("A Note on Names")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_04"
    }
  }, [_vm._v("A Note on Dates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_05"
    }
  }, [_vm._v("A Note on Spanish Naval Ranks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_06"
    }
  }, [_vm._v("A Note on Spanish Monetary Units")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_07"
    }
  }, [_vm._v("A Note of Spanish Flags and Royal Arms")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Some#lev_08"
    }
  }, [_vm._v("A Note on Conversions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chronology#lev_09"
    }
  }, [_vm._v("Chronology of the Trastamara and Habsburg Eras")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chronology1#lev_10"
    }
  }, [_vm._v("Chronology of the Bourbon Era")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_11"
    }
  }, [_vm._v("Historical Overview")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_12"
    }
  }, [_vm._v("Spain before the Hapsburgs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_13"
    }
  }, [_vm._v("The Sixteenth Century")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_14"
    }
  }, [_vm._v("The Seventeenth Century")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_15"
    }
  }, [_vm._v("The Eighteenth Century (to 1808)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Historical#lev_16"
    }
  }, [_vm._v("The Nineteenth Century (from 1808 to 1860)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Civilian#lev_17"
    }
  }, [_vm._v("Civilian and Naval Leaders of the Bourbon Spanish Navy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Successors#lev_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Regional’ Navies of Felipe II and his Successors")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Subsidiary#lev_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subsidiary Services and Squadrons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Subsidiary#lev_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coastguard ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("guardacostas")]), _vm._v(") Vessels")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Subsidiary#lev_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maritime Mail Services ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Correos Marítimos")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Subsidiary#lev_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Squadrons of Evolution")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Subsidiary#lev_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinas Consulares")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Trans#lev_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trans-Pacific Trade — the Manila Galleons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Fleet#lev_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fleet Lists (for Battles and Actions in which Spanish Naval vessels took part)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Naval#lev_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval Construction Programmes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Departmental#lev_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Departmental Organisation under the Bourbons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Departmental#lev_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanish Naval Arsenals, Dockyards and Shipbuilding")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Spanish#lev_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanish Naval Ordnance Development from 1600 to 1860")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Architecture#lev_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanish Naval Architecture")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Architecture#lev_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Era of the Habsburgs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Architecture#lev_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bourbon Era")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Copper#lev_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copper Sheathing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Material#lev_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Material Resource Management under the Bourbons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Personnel#lev_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval Personnel — Acquisition, Training, Maintenance and Retention under the Bourbons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Personnel#lev_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Available Manpower Resources")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Personnel#lev_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Naval Command Structure")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Sources#lev_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources and Archives")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bibliography#lev_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Glossary#lev_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary and Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1:")]), _vm._v(" The Three-decker Ships of the Line")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1769")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_01#lev_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired from 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2:")]), _vm._v(" Large Two-decker Ships of 80 guns and above")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1770")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_02#lev_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired after 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3:")]), _vm._v(" Two-decker Ships of ‘70’ (68 to 74) guns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1770")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_03#lev_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired from 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4:")]), _vm._v(" Two-decker Ships of ‘60’ (58 to 66) guns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1769")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_04#lev_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired from 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5:")]), _vm._v(" Ships and Frigates of 40 to 56 guns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1770")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_05#lev_70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired from 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6:")]), _vm._v(" Frigates of 20 to 36 guns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Vessels in service or on order at 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Vessels acquired from 1 November 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Vessels acquired from 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Vessels acquired from 1770")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(E)")]), _vm._v(" Vessels acquired from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_06#lev_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(F)")]), _vm._v(" Vessels acquired from 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7:")]), _vm._v(" Small Frigates ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fragatillas")]), _vm._v(") with fewer than 20 guns and Corvettes ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corbetas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8:")]), _vm._v(" Brigs ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bergantines")]), _vm._v(") and Brig-schooners ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bergantines-goletas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_08#lev_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Brigs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_08#lev_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Brig-schooners ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bergantines-goletas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter_09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9:")]), _vm._v(" Bomb vessels ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bombardas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10:")]), _vm._v(" Storeships ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urcas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11:")]), _vm._v(" Fireships ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brulotes")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12:")]), _vm._v(" Packets ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paquebotes")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13:")]), _vm._v(" Other Square-rigged Vessels — Polacres ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polacras")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumacas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_13#lev_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Polacres")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_13#lev_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumacas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#lev_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mediterranean vessels (with lateen sails)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14:")]), _vm._v(" Galleys ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galeras")]), _vm._v(") and Half-galleys ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galeotas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#lev_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Galleys extant in 1700")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#lev_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B")]), _vm._v(" Galleys acquired from 1 November 1700 to 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#lev_84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" Galleys of the Philippines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_14#lev_85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" Half-galleys ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galeotas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15:")]), _vm._v(" Xebecs ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jabeques")]), _vm._v(", including "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chambequines")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_15#lev_86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Xebecs chartered in 1742—1743")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_15#lev_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Xebecs acquired after 1750")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16:")]), _vm._v(" Pinks ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pingues")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saetías")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter_16#lev_88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Pinks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter_16#lev_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saetías")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17:")]), _vm._v(" Barks (Barcas) and Mystics ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Místicos")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_17#lev_90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Barks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_17#lev_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Mystics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18:")]), _vm._v(" Feluccas ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faluchos")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19:")]), _vm._v(" Other Minor Vessels with Mediterranean Rigs — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Escampavías")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tartanas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_19#lev_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Escampavías")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_19#lev_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tartanas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter_20#lev_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fore-and-aft rigged vessels")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20:")]), _vm._v(" Schooners ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goletas")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21:")]), _vm._v(" Pilot Boats ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pailebotes")]), _vm._v(") and Balajús")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_21#lev_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Pilot Boats")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_21#lev_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Balajús")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter_22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 22:")]), _vm._v(" Cutters ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Balandras")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter_23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 23:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flecheras")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 24:")]), _vm._v(" Other Minor Vessels with Fore-and-aft Rigs — Luggers ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lugres")]), _vm._v("), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quechemarines, Trincaduras")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Falúas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_24#lev_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Luggers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_24#lev_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quechemarines")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_24#lev_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(C)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trincaduras")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_24#lev_100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(D)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Falúas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Addendum#lev_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addendum: Steam-assisted Warships to 1860")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Addendum#lev_102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(A)")]), _vm._v(" Paddle Vessels")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Addendum#lev_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("(B)")]), _vm._v(" Screw Vessels")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Appendix_A#appA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: List of vessels participating in the 1588 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Felicísima")]), _vm._v(" Armada")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Appendix_B#appB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: List of vessels participating in the 1639 Battle of the Downs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Appendix_C#appC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: The 17th-century Ordinances governing shipbuilding")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Appendix_D#appD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: Numbers of ships in existence from 1782")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_Appendix_E#appE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E: Spanish naval expenditures")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Appendix_F#appF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix F: Ordnance regulations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ah"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Appendix_G#appG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix G: Official complements of Spanish warships")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0